var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_290_5961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6706 8.70898H2.17057C1.94057 8.70898 1.75391 8.88632 1.75391 9.10482V9.89648C1.75391 10.115 1.94057 10.2923 2.17057 10.2923H19.6706C19.9006 10.2923 20.0872 10.115 20.0872 9.89648V9.10482C20.0872 8.88632 19.9006 8.70898 19.6706 8.70898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6706 3.16699H2.17057C1.94057 3.16699 1.75391 3.34433 1.75391 3.56283V4.35449C1.75391 4.57299 1.94057 4.75033 2.17057 4.75033H19.6706C19.9006 4.75033 20.0872 4.57299 20.0872 4.35449V3.56283C20.0872 3.34433 19.9006 3.16699 19.6706 3.16699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6719 14.25H11.3385C11.1085 14.25 10.9219 14.4273 10.9219 14.6458V15.4375C10.9219 15.656 11.1085 15.8333 11.3385 15.8333H19.6719C19.9019 15.8333 20.0885 15.656 20.0885 15.4375V14.6458C20.0885 14.4273 19.9019 14.25 19.6719 14.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_290_5961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19,
    fill: "white",
    transform: "translate(0.921875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.d3a7953b7291695261c3d4b6a8d8ab1f.svg";
export { ForwardRef as ReactComponent };